var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H18M14 1V3M6 1V3M3 19H17C18.1046 19 19 18.1046 19 17V4C19 2.89543 18.1046 2 17 2H3C1.89543 2 1 2.89543 1 4V17C1 18.1046 1.89543 19 3 19ZM14 14.5H14.003V14.503H14V14.5ZM10 14.5H10.003V14.503H10V14.5ZM6 14.5H6.003V14.503H6V14.5ZM14 10.5H14.003V10.503H14V10.5ZM10 10.5H10.003V10.503H10V10.5ZM6 10.5H6.003V10.503H6V10.5Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.b4805029cb62c7c6712d84be7dd61e0f.svg";
export { ForwardRef as ReactComponent };